import { render, staticRenderFns } from "./TerminatedWorkerList.vue?vue&type=template&id=63c13544"
import script from "./TerminatedWorkerList.vue?vue&type=script&lang=js"
export * from "./TerminatedWorkerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports